var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    width: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fc6d52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11 1.125h-1.625v-.75a.375.375 0 1 0 -.75 0v.75h-2.25v-.75a.375.375 0 1 0 -.75 0v.75h-2.25v-.75a.375.375 0 1 0 -.75 0v.75h-1.625a1 1 0 0 0 -1 1v8.875a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-8.875a1 1 0 0 0 -1-1zm.25 9.875a.25.25 0 0 1 -.25.25h-10a.25.25 0 0 1 -.25-.25v-8.875a.25.25 0 0 1 .25-.25h1.625v.75a.375.375 0 1 0 .75 0v-.75h2.25v.75a.375.375 0 1 0 .75 0v-.75h2.25v.75a.375.375 0 1 0 .75 0v-.75h1.625a.25.25 0 0 1 .25.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.625 4.5h1.5v1.125h-1.5zm0 1.875h1.5v1.125h-1.5zm0 1.875h1.5v1.125h-1.5zm2.625 0h1.5v1.125h-1.5zm0-1.875h1.5v1.125h-1.5zm0-1.875h1.5v1.125h-1.5zm2.625 3.75h1.5v1.125h-1.5zm0-1.875h1.5v1.125h-1.5zm0-1.875h1.5v1.125h-1.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d8b9646d26fe20da191bfe0f16bd805f.svg";
export { ForwardRef as ReactComponent };